import { create } from 'zustand';

export type UpgradeTrigger = 'store_limit' | 'sales_channel_limit' | 'feature_gate' | 'staff_limit' | 'transaction_fees';

interface UpgradeState {
  isOpen: boolean;
  trigger: UpgradeTrigger | null;
  open: (trigger: UpgradeTrigger) => void;
  close: () => void;
}

export const useUpgradeStore = create<UpgradeState>((set) => ({
  isOpen: false,
  trigger: null,
  open: (trigger) => set({ isOpen: true, trigger }),
  close: () => set({ isOpen: false, trigger: null }),
}));
